/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { referral } from './referral';

export class referralindex extends referral {
  referral_index_key: string = "";
  payer_name: string = "";
  patient_name: string = "";
  requester_name: string = "";
  procedure_code1: string = "";
  procedure_code2: string = "";
  procedure_code3: string = "";
  procedure_title1: string = "";
  procedure_title2: string = "";
  procedure_title3: string = "";

  gettablename(): string {
    return "REFERRAL_INDEX";
  }
}
